// src/utils/sajdaUtils.js
export const parseSajdaData = (rawData) => {
    try {
      const data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
      
      // Create a mapping for easy lookup: surahNumber -> verseNumber -> sajdaInfo
      const sajdaMapping = {};
      
      if (data && data.data && Array.isArray(data.data.ayahs)) {
        data.data.ayahs.forEach(ayah => {
          const surahNumber = ayah.surah.number;
          const verseNumber = ayah.numberInSurah;
          
          if (!sajdaMapping[surahNumber]) {
            sajdaMapping[surahNumber] = {};
          }
          
          sajdaMapping[surahNumber][verseNumber] = {
            id: ayah.sajda.id,
            recommended: ayah.sajda.recommended,
            obligatory: ayah.sajda.obligatory
          };
        });
      }
      
      return sajdaMapping;
    } catch (error) {
      console.error('Error parsing sajda data:', error);
      return {};
    }
  };
  
  export const isSajdaVerse = (sajdaData, surahNumber, verseNumber) => {
    return !!(
      sajdaData && 
      sajdaData[surahNumber] && 
      sajdaData[surahNumber][verseNumber]
    );
  };
  
  export const getSajdaDetails = (sajdaData, surahNumber, verseNumber) => {
    if (isSajdaVerse(sajdaData, surahNumber, verseNumber)) {
      return sajdaData[surahNumber][verseNumber];
    }
    return null;
  };